<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Эргэлтийн (уулзах) цаг</h3>
            <p class="bullet03 depth">Өвчтөний аюулгүй байдлыг сахин хамгаалах, халдвараас урьдчилан сэргийлэхийн тулд эргэлтийн цагийг хязгаарласан бөгөөд уг журмыг мөрдөхийг хүсье.</p>
            <p class="bullet03 depth">Эргэлтийг 2 цагт багтаана. Өрөөнд нь орж уулзах бол ажлын өдрүүдэд 18:00~20:00 цагт, амралтын өдрүүдэд 10:00~12:00, 18:00~20:00 цагт орж болно. 20 цагаас хойш орж гарахыг хориглоно.</p>
            <p class="bullet03 depth">Эрчимт эмчилгээний тасагт 13:00~13:30 , 19:00~19:30 цагуудад орж уулзах боломжтой.</p>
            <p class="bullet03 depth">Өвчтөнг эмнэлэгт хэвтэх үед эмнэлгээс өгсөн асран хамгаалагчийн үнэмлэхтэй хүн чөлөөтэй нэвтрэх боломжтой.</p>
            <p class="bullet03 depth">Дархлаа суларсан болон халдварт өвчтэй өвчтөн, тусгаарлагдан эмчлүүлж байгаа тохиолдолд халдвар тархахаас урьдчилан сэргийлэх, өвчтөний аюулгүй байдлыг сахих зорилгоор эргэлт авахыг хориглодог.</p>
            <p class="bullet03 depth">Хувийн нууцаа хамгаалахыг хүсэх юм уу эргэлт авахыг хүсэхгүй байгаа бол эмнэлэгт хэвтэхдээ Санхүүгийн алба юм уу сувилагчид мэдэгдэнэ үү.</p>
            <p class="bullet03 depth">Эргэлт уулзалтын дэвтэрт заавал бүртгүүлнэ үү.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Эргэлт(уулзах) оруулах боломжгүй хүн</h3>
            <p class="bullet03 depth">Өвчтөнийг хурдан эдгэрэхэд нь туслах, аюулгүй байдлыг сахин хамгаалах, халдвараас урьдчилан сэргийлэхийн тулд 13-аас доош насны хүүхдийг халдварт өвчтэй өвчтөний өрөө болон эрчимт эмчилгээний өрөөнд оруулж уулзуулахыг хориглоно.</p>
            <p class="bullet03 depth">Ханиад болон халдварт өвчтэй асран хамгаалагчийг өвчтөнтэй уулзуулахгүй.</p>
            <p class="bullet03 depth">Халдвар тараах магадлалтай цэцгийн баглаа, тасалгааны цэцэг, гэрийн тэжээвэр амьтан зэргийг оруулахыг хориглоно.</p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>